import React, { FC } from 'react';
import { useFormikContext } from 'formik';

import { FormInput, Row, Column, HRule } from 'Shared/components';
import { PartnerFormValues } from 'Admin/Partners/components';

type PolicyAccessLevelType = {
  ancestorIds?: string[];
};

export const PolicyAccessLevel: FC<PolicyAccessLevelType> = ({
  ancestorIds,
}) => {
  const { values, setFieldValue } = useFormikContext<PartnerFormValues>();

  const isPrincipalAgency = ancestorIds?.length === 1;

  if (!isPrincipalAgency) {
    return null;
  }

  return (
    <>
      <HRule size="lg" />

      <h3>Policy access level</h3>

      <p>
        This controls which policies users at this partner can view and service.
        "Hierarchy scope" allows users to see policies across the full partner
        hierarchy regardless of which sub-partner or agency sold them.
      </p>

      <Row>
        <Column variant="half">
          <FormInput
            name="policyAccessLevel"
            variant="radioButtonGroup"
            data-testid="policy-access-level"
            label="Policy access level"
            onChange={(value: string) => {
              setFieldValue(
                'policyAccessLevel',
                value as 'agency_scope' | 'hierarchy_scope'
              );
            }}
            options={{
              agency_scope: 'Agency scope',
              hierarchy_scope: 'Hierarchy scope',
            }}
            value={values.policyAccessLevel ?? 'agency_scope'}
          />
        </Column>
      </Row>
    </>
  );
};
